// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2P9bK","questions":"styles_questions__B5Imf","footer":"styles_footer__11tHf"};